import React from "react";
import "./Structure.css";

const Structure = () => {
  return (
    <div className="serviceBg">
      <div className="container mx-auto">
        <h1
          className="ourServiceText text-center 2xl:text-left lg:mb-[16px] text-[35px] lg:text-[50px] leading-[50px] 2xl:mb-[50px]"
          data-aos="fade-right"
        >
          What is Mind Works?
        </h1>
        <div className="flex flex-col 2xl:flex-row gap-[75px] 2xl:gap-[150px] items-center">
          <div>
            <p
              className="text-center 2xl:text-left 2xl:w-[600px] px-[80px] 2xl:p-[0px] mb-[60px]"
              data-aos="zoom-in-up"
            >
              Mind Works is a global consulting and training organization with a
              strong footprint across South Asia and Vietnam. We specialize in
              driving organizational excellence through people-centric
              transformation and continuous improvement. Our mission is to help
              companies streamline operations, enhance efficiency, and build a
              lasting culture of continuous improvement—this is the Mind Works
              Way.
              <br /> <br /> We believe that every business challenge is unique.
              That’s why we reject one-size-fits-all approaches and focus
              instead on developing fully customized solutions. Our tailored
              strategies help organizations boost productivity, reduce defects
              and operational costs, and ultimately enhance profitability. All
              our consulting and training solutions are built with long-term
              sustainability in mind.
              <br /> <br />
              Mind Works proudly serves as the official PECB Partner in
              Bangladesh and has been honored with multiple accolades, including
              Best Strategy and Management Consulting Firm (2022) and Best
              Operational Excellence and Lean Transformation Firm in Bangladesh
              (2023 & 2024) by Wealth and Finance International, UK.
            </p>
          </div>
          <div
            className="flex flex-col 2xl:-mt-[100px]"
            data-aos="zoom-in-left"
          >
            <div className="flex flex-col-reverse items-center 2xl:items-start 2xl:flex-row gap-[5px] lg:gap-[10px]">
              <div className="servicePara  w-[250px] lg:w-[350px] mb-[20px]">
                <p className="justify-center text-center 2xl:text-right 2xl:justify-end block mx-auto lg:w-[400px]">
                  Assess Current State <br />
                  Identify Improvement Opportunities <br />
                  Strategy/Policy Deployment
                </p>
              </div>
              <h1 className="textOne text-[35px] lg:text-[40px] textContainer text-[#002060] text-center mb-[10px] ">
                Strategic
              </h1>
            </div>
            <div className="flex flex-col-reverse items-center 2xl:items-start 2xl:flex-row  gap-[5px] lg:gap-[10px]">
              <div className="servicePara  w-[250px] lg:w-[350px] mb-[20px]">
                <p className="justify-center text-center 2xl:text-right 2xl:justify-end block mx-auto lg:w-[400px]">
                  Training <br />
                  Culture of Continuous Improvement <br />
                  TOP : Takt - Flow - Pull
                </p>
              </div>
              <h1 className="textOne text-[35px] lg:text-[40px] textContainer text-[#002060] text-center mb-[10px] mt-[15px]">
                Tactical
              </h1>
            </div>
            <div className="flex flex-col-reverse items-center 2xl:items-start 2xl:flex-row  gap-[5px] lg:gap-[10px]">
              <div className="servicePara w-[250px] lg:w-[350px] mb-[20px]">
                <p className="justify-center text-center 2xl:text-right 2xl:justify-end lg:w-[400px] block mx-auto">
                  Shop Floor Kaizen <br />
                  Business Process Kaizen <br />
                  Sustainment <br />
                  SQDE
                </p>
              </div>
              <h1 className="textOne text-[35px] lg:text-[40px] textContainer text-[#002060] text-center mb-[10px] mt-[15px]">
                Operational
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Structure;
